import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { WIZARD_STEPS } from '../data/wizardSteps'
import type { StepId } from '../data/wizardSteps'

const STEP_IDS = WIZARD_STEPS.map((s) => s.id)

export function Wizard() {
  const [stepIndex, setStepIndex] = useState(0)
  const [answers, setAnswers] = useState<Record<StepId, string>>({} as Record<StepId, string>)
  const navigate = useNavigate()

  const step = WIZARD_STEPS[stepIndex]
  const currentValue = answers[step.id]
  const isLast = stepIndex === WIZARD_STEPS.length - 1

  const handleNext = () => {
    if (!currentValue) return
    if (isLast) {
      const params = new URLSearchParams()
      STEP_IDS.forEach((id) => {
        if (answers[id]) params.set(id, answers[id])
      })
      navigate(`/wizard/result?${params.toString()}`, { replace: true })
      return
    }
    setStepIndex((i) => i + 1)
  }

  const handleBack = () => setStepIndex((i) => Math.max(0, i - 1))

  return (
    <div className="page">
      <h1 className="section-title">智能引导中心</h1>
      <p className="lead" style={{ marginBottom: '2rem' }}>
        回答以下问题，获取专属部署方式与 Skills 推荐。所有结果均在本地生成，不上传任何密钥。
      </p>

      <div className="card">
        <div className="wizard-progress">
          {WIZARD_STEPS.map((s, i) => (
            <span
              key={s.id}
              className={i <= stepIndex ? 'active' : ''}
              aria-hidden
            >
              {i + 1}
            </span>
          ))}
        </div>
        <h2 style={{ marginBottom: '0.5rem' }}>{step.title}</h2>
        <p style={{ color: 'var(--text-muted)', marginBottom: '1.5rem' }}>
          {step.question}
        </p>
        <div className="wizard-options">
          {step.options.map((opt) => (
            <button
              key={opt.value}
              type="button"
              className={`wizard-opt ${currentValue === opt.value ? 'selected' : ''}`}
              onClick={() => setAnswers((a) => ({ ...a, [step.id]: opt.value }))}
            >
              {opt.label}
            </button>
          ))}
        </div>
        <div className="wizard-actions">
          <button type="button" className="btn btn-ghost" onClick={handleBack} disabled={stepIndex === 0}>
            上一步
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleNext}
            disabled={!currentValue}
          >
            {isLast ? '生成配置单' : '下一步'}
          </button>
        </div>
      </div>
    </div>
  )
}
